import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { InternalId } from '@edgebox/data-definition-kit';
import { ClientAiModelEntity } from '@edgebox/sync-core-rest-client';
import { useSyncCoreApi } from '../aiHelpers';

export interface AiModelNameProps {
  id?: string | InternalId;
  link?: boolean;
  fallback?: React.ReactNode;
}

export function AiModelName({ id, link = true, fallback = '-' }: AiModelNameProps) {
  const api = useSyncCoreApi();
  const [loading, setLoading] = useState(false);
  const [entity, setEntity] = useState<ClientAiModelEntity | undefined>(undefined);

  useEffect(() => {
    if (!api || !id) return;
    let cancelled = false;
    setLoading(true);

    api.ai.models
      .item(id as InternalId)
      .then((e) => {
        if (cancelled) return;
        setEntity(e);
      })
      .catch(() => {
        if (cancelled) return;
        setEntity(undefined);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [api, id]);

  if (!id) return <>{fallback}</>;
  if (loading && !entity) return <span className="text-muted">…</span>;

  const name = entity?.name;
  if (!name) return <span className="text-monospace">{String(id)}</span>;

  return link ? <Link to={`/ai/model/${String(id)}`}>{name}</Link> : <>{name}</>;
}
